import { useEffect } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { FormattedMessage } from 'react-intl';

import TopUpStatusMessage from './TopUpStatusMessage';

export const TopUpDeclined = () => {
    useEffect(() => {
        tracking.ampli.applicationDeclined();
    }, []);

    return (
        <TopUpStatusMessage
            heading={
                <FormattedMessage
                    id="_.outstanding_view.topupDeclined"
                    defaultMessage="Sorry, we can't approve you for more funds at the moment."
                />
            }
        />
    );
};
